import { render, staticRenderFns } from "./TraderType.vue?vue&type=template&id=7baaca62"
import script from "./TraderType.vue?vue&type=script&lang=js"
export * from "./TraderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports